<template>

<div class="form-overlay place-content" :class="position">
    <div class="steep1" v-if="placeSelected">
        <div class="content">
            <div class="list-item hide-scrollbar">
                <!-- <span class="loader" v-if="stateLoader"></span> -->
                <div class="item">
                    <div class="info">
                        <p class="localisation">{{ placeSelected.name }}</p>
                        <p class="localisation-info" v-if=" placeSelected.location">{{  placeSelected.location.street || placeSelected.location.city || placeSelected.location.country || placeSelected.location.zip  ? `${placeSelected.location.street} ${placeSelected.location.city} ${placeSelected.location.country} ${placeSelected.location.zip}` : placeSelected.name}}</p>
                    </div>
                    <i class="fa-regular fa-xmark" @click="removePlace"></i>
                </div>
                
            </div>
        </div>
    </div>
    
    <div class="steep2" v-else>
        <div class="content">
            <div class="input">
                <i class="fa-regular fa-magnifying-glass"></i>
                <input :placeholder="$t('dash.post-creator.overlay.search-place')" v-model="textSearch" v-on:keyup.enter="sendSearchPlace">
            </div>

            <div class="list-item hide-scrollbar">
                <span class="loader" v-if="stateLoader"></span>
                <template v-else-if="listPlacesAvailable.length">
                    <div class="item" v-for="(place,index) in listPlacesAvailable" @click="selectPlace(place)" :key="`localisation${index}`">
                    
                        <div class="info">
                            <p class="localisation">{{ place.name }}</p>
                            <p class="localisation-info" v-if="place.location">{{  place.location.street || place.location.city || place.location.country || place.location.zip  ? `${place.location.street || ''} ${place.location.city || ''} ${place.location.country || ''} ${place.location.zip || ''}` : place.name}}</p>
                        </div>
                
                    </div>
                </template>
                <p v-else-if="textSearch" class="no-result">{{ $t('dash.post-creator.overlay.no-place') }}</p>
                
            </div>
        </div>
    </div>
    <div class="btn-secondary" @click="$emit('close')">{{ $t('dash.button.close') }}</div>
</div>  
</template>

<script>
    import { EventBus } from '@/event-bus';
    export default {
        props: {
            network : String,
            
            placeSelected: {
                type: Object,
                default: undefined 
            },
            position: {
                type: String,
                default: 'left'
            },
        },

        data() {
            return {
                textSearch : '',
                lastIdEvent : 0,
                stateLoader : false,
                listPlacesAvailable : [],
                timeoutInitSearch : null,
            }
        },

        mounted () {
            EventBus.$on('resultSearchFromSelectPlace', this.receveidPlace);
        },

        methods: {
            sendSearchPlace() {
                if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
                this.stateLoader = true
                this.lastIdEvent = new Date().getTime()
                EventBus.$emit("eventSearchFromSelectPlace",this.network, this.textSearch,this.lastIdEvent)
            },

            receveidPlace(places,idEvent) {
                if (this.lastIdEvent == idEvent) {
                    this.listPlacesAvailable = places
                    this.stateLoader = false
                }
            },

            selectPlace(place) {
                console.log("selectPlace")
                EventBus.$emit("eventClickSelectPlace",this.network, place)
            },

            removePlace() {
                EventBus.$emit("eventRemoveSelectPlace", this.network)
            }
        },



        watch: {
            textSearch(newValue, oldValue) {
                if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
                this.stateLoader = true
                this.timeoutInitSearch = setTimeout(() => {
                    this.sendSearchPlace()
                },1000)
            },
        },

        beforeDestroy () {
            EventBus.$off('resultSearchFromSelectPlace', this.receveidPlace);
        }
    }
</script>
